module.exports = __webpack_public_path__ + "static/media/moon-icon.51ec6721.svg";